import { Auth } from 'aws-amplify';

export const isAdmin = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const groups = user.signInUserSession.accessToken.payload["cognito:groups"];

  return groups.includes('Admin'); // true
}
